/**
 * DevExtreme (esm/renovation/ui/scheduler/timeZoneCalculator/types.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var PathTimeZoneConversion;
! function(PathTimeZoneConversion) {
    PathTimeZoneConversion.fromSourceToAppointment = "toAppointment";
    PathTimeZoneConversion.fromAppointmentToSource = "fromAppointment";
    PathTimeZoneConversion.fromSourceToGrid = "toGrid";
    PathTimeZoneConversion.fromGridToSource = "fromGrid"
}(PathTimeZoneConversion || (PathTimeZoneConversion = {}));
